module.exports = __webpack_public_path__ + "img/sld_grid_ta1_ba1_dark.51074776.svg";